import { useEffect, useRef } from "react";
import {
  enqueueFirstWinsChatTrigger,
  scheduleTrackedChatTriggerDelay,
} from "@/hooks/chat/helpers/chatTriggerCoordinator";

export const useIdleTrigger = ({
  enabled,
  timeout,
  popModal,
  triggerChat,
  triggerKey,
  sessionEpoch = 0,
}) => {
  const hasTriggered = useRef(false);

  useEffect(() => {
    hasTriggered.current = false;
  }, [sessionEpoch]);

  useEffect(() => {
    if (!enabled) return;

    let cancelCountdown;

    const resetTimer = () => {
      if (cancelCountdown) cancelCountdown();
      cancelCountdown = scheduleTrackedChatTriggerDelay(
        triggerKey,
        "Idle",
        timeout,
        () => {
          if (hasTriggered.current) return;
          enqueueFirstWinsChatTrigger(() => {
            if (hasTriggered.current) return;
            const ran = triggerChat("Idle", { popModal, triggerKey });
            if (ran !== false) {
              hasTriggered.current = true;
            }
          });
        },
      );
    };

    const activityEvents = ["mousemove", "keydown", "scroll", "click"];
    activityEvents.forEach((e) => document.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      activityEvents.forEach((e) =>
        document.removeEventListener(e, resetTimer),
      );
      if (cancelCountdown) cancelCountdown();
    };
  }, [enabled, timeout, popModal, triggerChat, triggerKey, sessionEpoch]);
};
